<template>
  <div v-if="steps.length && me">
    <h2 class="text-4 mb-4">Things to do next</h2>
    <v-card>
      <div class="flex-align pa-4">
        <span class="text-4.5">
          Welcome, {{ me.first_name }} – follow these steps to get started
        </span>
        <v-spacer />
        <span>
          <Logo />
        </span>
      </div>
      <v-list class="py-0">
        <template v-for="(step, i) in steps" :key="i">
          <template v-if="isIncomplete(step)">
            <v-divider />
            <v-list-item class="py-3">
              <template #title>
                <router-link v-if="step.route" :to="{ name: step.route }">{{
                  step.title
                }}</router-link>
                <span v-else>{{ step.title }}</span>
              </template>
              <template #subtitle v-if="step.description">
                {{ step.description }}
              </template>

              <template #append v-if="!step.mandatory">
                <v-btn
                  @click="remove(step)"
                  size="small"
                  :loading="loading[step.handle]"
                  icon
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </template>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script lang="ts">
import { useMutation } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { set } from "lodash";
import type { OnboardStep } from "~/layers/admin/modules/auth/runtime/types/api";

export default defineComponent({
  name: "GettingStarted",
  setup() {
    const { me } = useAuth();
    const { nextSteps } = useAccountStatus();

    // Optimistic state of `completed` steps
    const complete = reactive<Record<string, boolean>>({});
    const loading = reactive<Record<string, boolean>>({});

    const isIncomplete = (step: OnboardStep) => {
      return !(step.complete || complete[step.handle] === true);
    };

    const steps = computed(() => {
      return nextSteps.value.map((step) => ({
        ...step,
        route: match(step.handle, {
          account: "onboarding",
          "learn-basics": "docs",
          products: "products-new",
          events: "events-new",
          shipping: "settings-shipping",
          plan: "access-pricing",
        }),
      }));
    });

    const mutation = useMutation(gql`
      mutation ($handle: String!) {
        wsCompleteOnboardStep(handle: $handle) {
          next_steps {
            handle
          }
        }
      }
    `);

    const remove = async (step: OnboardStep) => {
      set(loading, step.handle, true);
      await mutation.mutate({ handle: step.handle });
      // await refetch();
      set(loading, step.handle, false);
      set(complete, step.handle, true);
    };

    return {
      steps,
      loading,
      complete,
      me,
      isIncomplete,
      remove,
    };
  },
});
</script>
